export interface IMyMillMachineItem {
    id: string;
    name: string;
    serialNumber: string;
}

export class MyMillMachineItem implements IMyMillMachineItem {
    public id: string;
    public name: string;
    public serialNumber: string;

    constructor();
    // tslint:disable-next-line: unified-signatures
    constructor(obj: IMyMillMachineItem);
    constructor(obj?: any) {
        this.id = obj && obj.id || '';
        this.name = obj && obj.name || '';
        this.serialNumber = obj && obj.serialNumber || '';
    }
}
